import React, { useState, useEffect, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES, SERVICE_ROUTES } from '../data/siteLinks';

interface HizmetlerPageProps {
  category?: string;
}

interface AdvantageItem {
  term: string;
  description: string;
}

interface ContentSection {
  id?: string;
  heading: string;
  body: string;
  price?: string;
}

interface ServiceCategory {
  id: string;
  title: string;
  path: string;
  heading: string;
  searchIntro: string;
  paragraphs: string[];
  advantages: AdvantageItem[];
  /** Vize gibi sekmelerde tek başlık+avantaj yerine çoklu başlık+gövde
   * blokları için kullanılır. Doluysa varsayılan layout yerine bu render edilir. */
  sections?: ContentSection[];
}

const serviceCategories: ServiceCategory[] = [
  {
    id: 'goc-oncesi',
    title: 'Süreç Rehberliği',
    path: SERVICE_ROUTES.migrationPreparation,
    heading: 'Rehberlik ve Destek Hizmeti',
    searchIntro:
      "Almanya'ya göç hazırlığı, vize ve oturum öncesi organizasyon, eğitim, ev kiralama ve yerleşim adımları için sunduğumuz deneyime dayalı rehberlik hizmetlerini inceleyebilirsiniz.",
    paragraphs: [
      "Almanya'ya göç sürecinizi daha planlı ve bilinçli bir şekilde hazırlayabilmeniz için deneyim paylaşımları ve bilgiler sunuyoruz. Temel amacımız, idari hazırlık aşamalarını kendi başınıza planlayabilmenize yardımcı olmak. Süreç boyunca size eşlik ediyor, karşılaşabileceğiniz operasyonel sorulara yönelik tecrübelerimizi paylaşıyoruz.",
      "Hazırlık aşamasında hangi adımları ne zaman atmanız gerektiği konusunda sizi bilgilendirerek, idari hazırlıklarınızı en verimli şekilde planlamanıza yardımcı oluruz.",
    ],
    advantages: [
      {
        term: 'Zaman Tasarrufu',
        description:
          "Saatlerce araştırma yapmak yerine, hazırlık sürecinde ihtiyacınız olan pratik bilgileri tecrübelerimiz ışığında hızlıca öğrenebilirsiniz.",
      },
      {
        term: 'Kontrol Sizde',
        description:
          'Hazırlıkların kontrolü tamamen sizin elinizde. Hangi aşamada hangi idari adımı atmanız gerektiğini bilerek, sürecinizi güvenle yürütebilirsiniz.',
      },
      {
        term: 'Deneyim Odaklı',
        description:
          'Süreci bizzat tecrübe etmiş bir rehberden destek alarak, operasyonel adımları doğru zamanda planlayacağınızdan emin olabilirsiniz.',
      },
    ],
  },
  {
    id: 'vize',
    title: 'Vize',
    path: SERVICE_ROUTES.visa,
    heading: 'Vize Başvuru Rehberliği',
    searchIntro:
      "Almanya vize başvurusu; Blue Card vizesi, Fırsat Kartı (Chancenkarte), çalışma vizesi, iş arama vizesi, aile birleşimi vizesi ve öğrenci vizesi hazırlıkları için deneyime dayalı rehberlik seçeneklerimizi inceleyebilirsiniz.",
    paragraphs: [],
    advantages: [],
    sections: [
      {
        heading: 'Blue Card Vizesi',
        price: '480 €',
        body:
          "Mavi Kart alma süreci, resmi kriterlerin dikkatli bir şekilde incelenmesini ve gerekli belgelerin eksiksiz hazırlanmasını gerektirir. Almanya göçmenlik düzenlemeleri hakkında bilgiler sunuyor ve işleyiş süreçlerini kapsamlı bir şekilde açıklıyoruz. Deneyimlerimiz, belgelerin düzenlenmesinden randevu alınmasına kadar hazırlık sürecinin tüm yönlerini kapsamakta olup; bu sayede sürecinizin her bir adımını daha iyi planlayabilirsiniz.",
      },
      {
        heading: 'Fırsat Kart (Chancenkarte)',
        price: '480 €',
        body:
          "Fırsat Kartı başvuru süreci, belirli kriterlerin yerine getirilmesini ve idari gereklilikleri kapsar. Bilgilendirme ve danışmanlık hizmetimizle, gereklilikler hakkında kapsamlı bir genel bakış sunuyor ve deneyimlerimizi sizinle paylaşıyoruz. Hedefimiz, bu sürecin en uygun şekilde planlanmasında size destek olmaktır.",
      },
      {
        heading: 'Çalışma Vizesi',
        price: '480 €',
        body:
          "Almanya, her biri farklı idari gerekliliklere tabi olan çok sayıda çeşitli iş vizesi kategorisi sunmaktadır. Süreç destek hizmetimiz, başvuru sahipleri için çok sayıda bilgi ve deneyim paylaşımını bir araya getirmekte ve bu sayede süreçlerin tüm işleyişinin anlaşılmasına yardımcı olmaktadır.",
      },
      {
        heading: 'İş Arama Vizesi',
        price: '480 €',
        body:
          "Almanya iş arama vizesi, nitelikli bireylere Almanya'daki iş arama süreçlerini sistematik bir şekilde planlama imkanı tanır. Hazırlık desteğimiz, gerekli belgelerin bir araya getirilmesine ve idari başvuru adımlarına yönelik bilgileri kapsamaktadır. Deneyimlerimiz sayesinde, iş arama sürecindeki kendi adımlarınızı hedef odaklı bir şekilde atabilirsiniz.",
      },
      {
        heading: 'Aile Birleşimi Vizesi',
        price: '480 €',
        body:
          "Aile birleşimi süreci, formların doldurulmasını ve belgelerin bir araya getirilmesini kapsar. Bilgi ve deneyimlerimizle, başvuru sahiplerini her adım hakkında bilgilendirerek sürecin sorunsuz ilerlemesine katkıda bulunuyoruz.",
      },
      {
        heading: 'Öğrenci Vizesi',
        price: '480 €',
        body:
          "Eğitim amaçlı vize süreci; dil okullarına veya üniversitelere kayıt için belgelerin bir araya getirilmesini gerektiren bir hazırlık aşamasını kapsar. İlgilenenlere bu sürecin işleyişi hakkında detaylı bilgiler sunuyor; gerekli belgelerin bir araya getirilmesinden münferit adımların planlanmasına kadar süreci kendi başınıza yönetebilmeniz için organizasyonel destek sağlıyoruz.",
      },
    ],
  },
  {
    id: 'oturum',
    title: 'Oturum',
    path: SERVICE_ROUTES.residence,
    heading: 'Oturum İzni Rehberliği',
    searchIntro:
      "Almanya oturum izni başvurusu; Blue Card oturumu, çalışma vizesinden oturuma geçiş, aile birleşimi oturumu, oturum uzatma, iş değişikliği ve süresiz oturum hazırlıkları hakkında bilgi alabilirsiniz.",
    paragraphs: [],
    advantages: [],
    sections: [
      {
        heading: 'Blue Card Oturum',
        price: '850 €',
        body:
          "Almanya'da Mavi Kart başvurusu; resmi kriterlerin incelenmesini ve Yabancılar Dairesi nezdindeki başvuru sürecinin hazırlanmasını kapsar. Danışmanlık hizmetimiz, işleyiş süreçleri hakkında size kapsamlı bilgiler sunmaktadır. Belgelerin tasnif edilmesinden randevu alınmasına kadar tüm süreçteki deneyimlerimizden faydalanırsınız. Hedefimiz, bu hazırlığın en uygun şekilde planlanmasında size destek olmaktır.",
      },
      {
        heading: 'Çalışma vizelerinin oturuma çevrilmesi',
        price: '850 €',
        body:
          "Bir çalışma vizesinin oturum iznine dönüştürülmesi, Almanya'da oturum izni başvurusu için gerekli idari adımların atılmasını gerektirir. Bu işlemlere dair bilgilerimiz ve kapsamlı deneyimlerimiz, kendi başvuru hazırlığınızı sorunsuz ve düzenli bir şekilde gerçekleştirmenize yardımcı olur.",
      },
      {
        heading: 'Aile birleşimi oturum izni',
        price: '850 €',
        body:
          "Aile Birleşimi Oturum İzni hazırlık desteğimiz, Almanya'da yerleşim sürecini hedefleyen bireylere organizasyonel rehberlik sunar. Bu hizmetle, gerekli belgelerin tasnifi ve idari hazırlık adımları hakkında bilgi paylaşımı sağlayarak, hazırlık sürecinizi kendi başınıza planlamanıza destek oluyoruz.",
      },
      {
        heading: 'Oturum Uzatma İşlemleri',
        price: '850 €',
        body:
          "Oturum Uzatma hazırlık desteğimiz, Almanya'da ikamet eden bireylere, izin süreleri dolmadan önceki idari hazırlık aşamalarında organizasyonel rehberlik sunar. Başvuru sahiplerinin gerekli adımları ve idari süreçleri anlamalarına yardımcı oluyor, hazırlıkların planlı bir şekilde ilerlemesine tecrübelerimizle destek sağlıyoruz.",
      },
      {
        heading: 'İş Değişikliği İdari Hazırlık Desteği',
        price: '850 €',
        body:
          "Almanya'da iş değişikliği planlayan çalışanlar için hazırlık süreçlerinde destek sunuyoruz. Gerekli bildirim prosedürleri ve belgelerin oluşturulması hakkında kapsamlı uzmanlığa sahibiz ve bu bilgileri müşterilerin kullanımına sunuyoruz.",
      },
      {
        heading: 'Sınırsız Oturum',
        price: '850 €',
        body:
          "Daimi oturum izni başvurusu için sunduğumuz destek; gerekli kriterler ve idari hazırlık adımları hakkında bilgilerin sağlanmasını kapsamaktadır. Başvuru sahiplerinin belgelerini etkin bir şekilde hazırlamalarına ve süreci doğru adımlarla planlamalarına yardımcı olmak amacıyla uzmanlığımızı müşterilerimizle paylaşıyoruz.",
      },
    ],
  },
  {
    id: 'egitim',
    title: 'Eğitim',
    path: SERVICE_ROUTES.education,
    heading: 'Eğitim Sistemi Rehberliği',
    searchIntro:
      "Almanya'da üniversite başvurusu, dil okulu kaydı, öğrenci vizesi hazırlığı, Kita/Kindergarten/Tagesmutter başvurusu ve okul kayıt süreci için sunduğumuz rehberlik hizmetlerini inceleyebilirsiniz.",
    paragraphs: [],
    advantages: [],
    sections: [
      {
        id: 'universite-rehberligi',
        heading: 'Üniversite Başvuru, Kayıt ve Vize Hazırlık Rehberliği',
        price: '1.800 €',
        body:
          "Almanya'da eğitim görmek isteyen öğrenciler için üniversite seçimi ve kayıt süreçlerinde organizasyonel destek sunuyoruz. Bu hizmet; çeşitli üniversite seçeneklerinin incelenmesini, kayıt için gerekli belgelerin bir araya getirilmesini, hesap açılışı ve vize başvurusu hakkındaki bilgileri kapsamaktadır. Hedefimiz, öğrencilerin bu süreci kendi başlarına planlayabilmeleri için deneyimlerimizi aktarmaktır.",
      },
      {
        id: 'dil-okulu-rehberligi',
        heading: 'Dil Okulu Başvuru, Kayıt ve Vize Hazırlık Rehberliği',
        price: '950 €',
        body:
          "Almanya'da dil kursuna gitmeyi planlayan herkes için dil okulu seçimi ve kayıt süreçlerinde organizasyonel destek sunuyoruz. Adımlar, kayıt belgelerinin oluşturulması ve vize düzenlemeleri konusundaki deneyimlerimizi paylaşıyoruz. Böylece öğrencilerin hazırlık aşamalarını daha donanımlı ve yapılandırılmış bir şekilde tasarlamalarına yardımcı oluyoruz.",
      },
      {
        id: 'kindergarten-rehberligi',
        heading: 'Kindergarten ve Tagesmutter Kayıt Rehberliği',
        price: '230 €',
        body:
          'Ebeveynlere, çocuklarının anaokuluna veya gündüz bakımevine kaydı konusunda destek sunuyoruz. Bu hizmet; yakınınızdaki seçenekler hakkında bilgilendirmeyi, kayıt prosedürlerini ve gerekli belgelerin bir araya getirilmesini kapsamaktadır. Deneyimlerimiz sayesinde ebeveynler, münferit kayıt aşamalarını sorunsuz bir şekilde planlayabilirler.',
      },
      {
        id: 'okul-kayit-rehberligi',
        heading: 'Okul Kayıt Süreci Rehberliği',
        price: '230 €',
        body:
          "Almanya'daki okul sistemi ve kayıt süreçleri hakkında ailelere organizasyonel rehberlik sunuyoruz. Uygun okul türlerinin tanıtılması, kayıt için gerekli idari belgelerin tasnifi ve başvuru adımları hakkında yönlendirici bilgiler paylaşıyoruz. Ailelerin okul sistemini anlamalarına ve kayıt hazırlıklarını planlı bir şekilde yürütmelerine yardımcı oluyoruz.",
      },
    ],
  },
  {
    id: 'kiralama',
    title: 'Daire Kiralama',
    path: SERVICE_ROUTES.housing,
    heading: "Almanya'da Ev ve Daire Kiralama Rehberliği",
    searchIntro:
      "Almanya'da eşyalı ev kiralama, mobilyalı daire veya geçici konaklama arama, Almanya'ya gelmeden ev bulma hazırlığı ve boş daire kiralama süreci için deneyime dayalı rehberlik sunuyoruz.",
    paragraphs: [],
    advantages: [],
    sections: [
      {
        id: 'esyali-daire-rehberligi',
        heading: 'Eşyalı Daire Kiralama Rehberliği',
        price: '1.200 €',
        body:
          "Almanya'da ev kiralama sürecinde eşyalı bir daire arayan ve kısa ya da orta vadeli konaklama planlayan kişilere deneyime dayalı organizasyonel rehberlik sunuyoruz. Almanya'daki ev kiralama siteleri ve diğer uygun platformlar üzerinden seçeneklerin incelenmesi, gerekli evrakların tasnifi ve başvuru hazırlıkları hakkında tecrübelerimizi paylaşıyoruz. Köln'de ev kiralama sürecinde edindiğimiz deneyimlerden de yararlanarak, hazırlıklarınızın daha planlı ve düzenli ilerlemesine yardımcı olmayı amaçlıyoruz.",
      },
      {
        heading: 'Boş Daire Kiralama Rehberliği',
        price: '1.200 €',
        body:
          "Almanya'da daire kiralama sürecinde boş ve uzun vadeli bir konut arayan veya mevcut evini değiştirmek isteyen kişilere hazırlık desteği sunuyoruz. Bu hizmet; kira piyasasının işleyişi, uygun seçeneklerin incelenmesi ve başvuru dosyasının oluşturulması gibi önemli adımlar hakkında deneyime dayalı bilgilendirmeyi kapsar. Asıl kiralama işlemi ve sözleşme imzalanması, başvuru sahiplerinin kendileri tarafından gerçekleştirilmektedir.",
      },
    ],
  },
  {
    id: 'entegrasyon',
    title: 'Entegrasyon',
    path: SERVICE_ROUTES.integration,
    heading: 'Yeni Hayata Uyum Desteği',
    searchIntro:
      "Almanya'ya yeni gelenler için günlük yaşam hazırlıkları, ilk yerleşim adımları ve Almanya'da entegrasyon kursu başvurusu hakkında deneyime dayalı destek seçeneklerini inceleyebilirsiniz.",
    paragraphs: [],
    advantages: [],
    sections: [
      {
        id: 'ilk-gelenler-icin-yonlendirme',
        heading: 'Almanya\'ya İlk Gelenler İçin Yönlendirme ve Destek',
        price: '380 €',
        body:
          "Almanya'ya yeni gelenler için sunduğumuz yönlendirme ve destek hizmeti, ülkeye yerleşim sürecindeki bireylere günlük yaşamda rehberlik sağlar. Bu hizmet; market alışverişinden telefon hattı açmaya, ulaşım seçeneklerinden sosyal hayata dair pratik bilgilere kadar pek çok konuda tecrübe paylaşımı sunar. Ayrıca, kültürel uyum ve toplumsal yapıyı anlamanıza yardımcı olarak, Almanya'daki yeni başlangıcınızı daha bilinçli ve kolay hale getirir.",
      },
      {
        heading: 'Entegrasyon Kursu Başvuru Rehberliği',
        price: '175 €',
        body:
          "Almanya'ya yerleşen bireylere, entegrasyon kursu başvuru kriterleri ve idari adımlar hakkında yol gösterilir. Yabancılar dairesi ve ilgili kurumlar nezdinde kurs desteği talep edebilmeniz için yapılması gereken operasyonel işlemler konusunda deneyimlerimizi paylaşıyoruz. Amacımız, başvuru hazırlıklarınızın planlı bir şekilde ilerlemesine ve uyum sürecinizin kolaylaşmasına destek olmaktır.",
      },
    ],
  },
  {
    id: 'goc-sonrasi',
    title: 'Göç Sonrası',
    path: SERVICE_ROUTES.postMigration,
    heading: 'Göç Sonrası Süreçler',
    searchIntro:
      "Almanya'da Anmeldung (adres kaydı), banka hesabı açma ve sağlık sigortası işlemlerine hazırlık gibi göç sonrası ilk adımlar için deneyime dayalı rehberlik seçeneklerini inceleyebilirsiniz.",
    paragraphs: [],
    advantages: [],
    sections: [
      {
        id: 'anmeldung-rehberligi',
        heading: 'Anmeldung (Adres Kaydı) Rehberliği',
        price: '45 €',
        body:
          "Almanya'ya yerleşmenin en önemli adımı olan ikametgah kaydınız (Anmeldung) konusunda size bilgiler ve deneyimler sunuyoruz. Bu hizmet; randevu alınmasına dair bilgileri ve gerekli formların doldurulması konusundaki deneyimlerimizi kapsamaktadır. Hedefimiz, ikametgah kaydı hazırlıklarınızda sizi kapsamlı ve sistematik bir şekilde desteklemektir.",
      },
      {
        id: 'banka-hesabi-rehberligi',
        heading: 'Banka Hesabı Açma Rehberliği',
        price: 'Ücretsiz',
        body:
          "Almanya'da günlük finansal işlemlerinizi yönetebilmeniz için banka hesabı açma süreçleri hakkında bilgilendirme sağlıyoruz. Bu süreçteki idari adımları öğrenmenize ve kayıt hazırlıklarını yapmanıza yardımcı olan rehberliğimizle yanınızdayız.",
      },
      {
        id: 'saglik-sigortasi-rehberligi',
        heading: 'Sağlık Sigortası Rehberliği',
        price: 'Ücretsiz',
        body:
          "Almanya'da yasal bir zorunluluk olan sağlık sigortası sistemini anlamanız ve idari gereklilikleri değerlendirmeniz için hazırlık desteği sunuyoruz. Sağlık sigortası sistemine dair bilgilendirme hizmetimiz, işlemlerinizin hazırlık aşamasında hızlı ilerlemesi için rehberlik sağlar.",
      },
    ],
  },
];

const HizmetlerPage: React.FC<HizmetlerPageProps> = ({ category }) => {
  const location = useLocation();
  const propIndex = useMemo(() => {
    if (!category) return 0;
    const idx = serviceCategories.findIndex((s) => s.id === category);
    return idx >= 0 ? idx : 0;
  }, [category]);

  const [activeIndex, setActiveIndex] = useState(propIndex);

  useEffect(() => {
    setActiveIndex(propIndex);
  }, [propIndex]);

  useEffect(() => {
    if (!location.hash) return;

    if (!category && location.hash === '#hizmet-ucretleri') {
      setActiveIndex(1);
    }

    const sectionId = decodeURIComponent(location.hash.slice(1));
    window.requestAnimationFrame(() => {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, [category, location.hash]);

  const activeService = serviceCategories[activeIndex];

  return (
    <div className="hizmetler-page">
      {/* 1. Hero */}
      <section className="hizmetler-hero">
        <div className="container">
          <h1 className="hizmetler-hero-title">Hizmetler</h1>
          <div className="hizmetler-hero-text">
            <p>
              Almanya'ya taşınma sürecindeki işleyişi ve hazırlıkları sizin için anlaşılır kılmak adına
              deneyimlerimizi kullanıyoruz. Bu sürecin operasyonel ve organizasyonel aşamalarında, kişisel
              tecrübelerimiz temelinde size eşlik ediyor ve planlamanızda destek sağlıyoruz.
            </p>
            <p>
              Hukuki analiz veya değerlendirme gerektiren tüm sorularda, geçiş sürecine hukuki güvenlik
              içinde eşlik eden, uzun yıllara dayanan deneyime sahip hukuk ortağımız Avukat Dr. Hayrullah
              Özcan ile iletişim kurmanızı memnuniyetle sağlıyoruz.
            </p>
            <p>
              Aşağıda süreç hazırlık ve destek paketlerimiz hakkında bilgi edinebilir, daha fazla detay
              için randevu alabilirsiniz.
            </p>
          </div>
        </div>
      </section>

      {/* 2. Tabs */}
      <section id="hizmet-ucretleri" className="hizmetler-tabs-section">
        <div className="container">
          <div className="hizmetler-tabs-row">
            {serviceCategories.map((service, index) => (
              <button
                key={service.id}
                type="button"
                className={`hizmetler-tab ${index === activeIndex ? 'active' : ''}`}
                onClick={() => setActiveIndex(index)}
                aria-pressed={index === activeIndex}
              >
                {service.title}
              </button>
            ))}
          </div>

          <p className="hizmetler-search-intro">{activeService.searchIntro}</p>

          {/* 3. Two-column content */}
          {activeService.sections && activeService.sections.length > 0 ? (
            // Çoklu başlık+gövde bloğu (örn. Vize sekmesi)
            <div className="hizmetler-sections">
              {activeService.sections.map((section, i) => (
                <div key={section.id ?? i} id={section.id} className="hizmetler-content-grid">
                  <div className="hizmetler-content-title">
                    <h2>{section.heading}</h2>
                    {section.price && (
                      <div className="hizmetler-section-price">
                        <span>Hizmet bedeli</span>
                        <strong>{section.price}</strong>
                      </div>
                    )}
                  </div>
                  <div className="hizmetler-content-body">
                    <p>{section.body}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            // Varsayılan: tek başlık + paragraflar + avantajlar listesi
            <div className="hizmetler-content-grid">
              <div className="hizmetler-content-title">
                <h2>{activeService.heading}</h2>
              </div>
              <div className="hizmetler-content-body">
                {activeService.paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
                {activeService.advantages.length > 0 && (
                  <>
                    <p className="hizmetler-advantages-label">Avantajlar</p>
                    <ul className="hizmetler-advantages">
                      {activeService.advantages.map((adv, i) => (
                        <li key={i}>
                          <span className="hizmetler-advantage-term">{adv.term}:</span>{' '}
                          {adv.description}
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* 4. Randevu Alın CTA */}
      <section className="hizmetler-randevu">
        <div className="container">
          <div className="hizmetler-randevu-grid">
            <div className="hizmetler-randevu-text">
              <h2>Randevu Alın</h2>
              <p>
                Hizmetlerimiz hakkında daha fazla bilgi almak ve idari hazırlık süreci detaylarını
                öğrenmek için bizimle iletişime geçebilirsiniz.
              </p>
              <p>
                Sürece dair operasyonel sorularınızı yanıtlamak ve hazırlık aşamalarına dair genel
                bilgilendirme görüşmesi oluşturmak için randevunuzu kolayca planlayabilirsiniz.
              </p>
              <Link to={ROUTES.appointment} className="hizmetler-randevu-btn">
                Randevu Alın
              </Link>
            </div>
            <div className="hizmetler-randevu-image">
              <img src="/images/randevu.png" alt="Randevu" loading="lazy" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HizmetlerPage;
